import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from './locales/en/common.json';
import commonFR from './locales/fr/common.json';
import commonDE from './locales/de/common.json';
import commonES from './locales/es/common.json';
import commonIT from './locales/it/common.json';

import homeEN from './locales/en/home.json';
import homeFR from './locales/fr/home.json';
import homeDE from './locales/de/home.json';
import homeES from './locales/es/home.json';
import homeIT from './locales/it/home.json';

import calculatorEN from './locales/en/calculator.json';
import calculatorFR from './locales/fr/calculator.json';
import calculatorDE from './locales/de/calculator.json';
import calculatorES from './locales/es/calculator.json';
import calculatorIT from './locales/it/calculator.json';

import privacyEN from './locales/en/privacy.json';
import privacyFR from './locales/fr/privacy.json';
import privacyDE from './locales/de/privacy.json';
import privacyES from './locales/es/privacy.json';
import privacyIT from './locales/it/privacy.json';

import aboutEN from './locales/en/about.json';
import aboutFR from './locales/fr/about.json';
import aboutDE from './locales/de/about.json';
import aboutES from './locales/es/about.json';
import aboutIT from './locales/it/about.json';

import contactEN from './locales/en/contact.json';
import contactFR from './locales/fr/contact.json';
import contactDE from './locales/de/contact.json';
import contactES from './locales/es/contact.json';
import contactIT from './locales/it/contact.json';

// Translation resources
const resources = {
  en: {
    common: commonEN,
    home: homeEN,
    calculator: calculatorEN,
    privacy: privacyEN,
    about: aboutEN,
    contact: contactEN
  },
  fr: {
    common: commonFR,
    home: homeFR,
    calculator: calculatorFR,
    privacy: privacyFR,
    about: aboutFR,
    contact: contactFR
  },
  de: {
    common: commonDE,
    home: homeDE,
    calculator: calculatorDE,
    privacy: privacyDE,
    about: aboutDE,
    contact: contactDE
  },
  es: {
    common: commonES,
    home: homeES,
    calculator: calculatorES,
    privacy: privacyES,
    about: aboutES,
    contact: contactES
  },
  it: {
    common: commonIT,
    home: homeIT,
    calculator: calculatorIT,
    privacy: privacyIT,
    about: aboutIT,
    contact: contactIT
  }
};

// Language detector configuration
const detectionOptions = {
  // Order of language detection
  order: ['path', 'localStorage', 'navigator'],

  // Keys for localStorage
  lookupLocalStorage: 'orram-language',

  // Cache user language
  caches: ['localStorage'],

  // Only detect languages we support
  checkWhitelist: true
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en', // Fallback language
    supportedLngs: ['en', 'fr', 'de', 'es', 'it'], // Supported languages

    detection: detectionOptions,

    // Default namespace
    defaultNS: 'common',

    // Interpolation settings
    interpolation: {
      escapeValue: false // React already escapes values
    },

    // React settings
    react: {
      useSuspense: true // Use Suspense for loading translations
    },

    // Debug mode (disable in production)
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;
